module.exports = __webpack_public_path__ + "img/icon4.6f2e8ac8.png";